'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CodeCard = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CodeCard, _Component);

  function CodeCard() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CodeCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CodeCard.__proto__ || (0, _getPrototypeOf2.default)(CodeCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CodeCard, [{
    key: 'handleRemove',

    // onChangeCode(e) {
    //   const text = e.target.value;
    //   this.setState({ code: text });
    // }
    value: function handleRemove(e) {
      var _props = this.props,
          onRemove = _props.onRemove,
          value = _props.value,
          manualTrack = _props.manualTrack,
          tracking = _props.tracking;

      if (onRemove) onRemove(e);
      if (manualTrack) manualTrack((0, _extends3.default)({}, tracking, { button: 'Remove code', label: value }));
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _props2 = this.props,
          type = _props2.type,
          onClick = _props2.onClick,
          tracking = _props2.tracking,
          manualTrack = _props2.manualTrack,
          value = _props2.value;

      if (!type || type === 'default') onClick(e);
      if (manualTrack) manualTrack((0, _extends3.default)({}, tracking, { button: 'Apply code', label: value }));
    }
  }, {
    key: 'render',
    value: function render() {
      // const { code } = this.state;
      var _props3 = this.props,
          name = _props3.name,
          type = _props3.type,
          leftIcon = _props3.leftIcon,
          value = _props3.value,
          onChangeCode = _props3.onChangeCode;

      var styles = require('./CodeCard.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.box },
        type === 'default' ? _react2.default.createElement(
          'div',
          { className: styles.group },
          leftIcon && _react2.default.createElement('img', { className: styles.icon, src: leftIcon, alt: '' }),
          _react2.default.createElement('input', {
            value: value,
            onChange: onChangeCode,
            className: styles.inputCode,
            type: 'text',
            placeholder: name
          }),
          _react2.default.createElement(
            'button',
            { onClick: this.handleClick.bind(this) },
            '\xC1p D\u1EE5ng'
          )
        ) : _react2.default.createElement(
          'div',
          { className: styles.group },
          leftIcon && _react2.default.createElement('img', { className: styles.icon, src: leftIcon, alt: '' }),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            name
          )
        ),
        !!(type === 'active') && _react2.default.createElement('i', { className: styles.valid + ' fa fa-check' }),
        !!(type === 'inactive') && _react2.default.createElement('i', { className: styles.invalid + ' fa fa-times' }),
        !!(type && type !== 'default') && _react2.default.createElement(
          'div',
          { className: 'hihi ' + styles.btnRemove, onClick: this.handleRemove.bind(this) },
          _react2.default.createElement('i', { className: 'fa fa-close' })
        )
      );
    }
  }]);
  return CodeCard;
}(_react.Component), _class.propTypes = {
  name: _react.PropTypes.string,
  value: _react.PropTypes.string,
  type: _react.PropTypes.string,
  leftIcon: _react.PropTypes.string,
  rightIcon: _react.PropTypes.string,
  tracking: _react.PropTypes.object,
  // @action
  onClick: _react.PropTypes.func,
  onChangeCode: _react.PropTypes.func,
  onRemove: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func
}, _temp2);
exports.default = CodeCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/CodeCard.js
// module id = 1554
// module chunks = 0